import React, { useEffect, useRef, useState } from 'react';
import { Segment, Icon, Header, Image, Modal, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { HtmlEditor } from 'devextreme-react/html-editor';
import McqsQuestionTemplate from '../Templates/McqsQuestionCpaTemplate';
import TextQuestionTemplate from '../Templates/TextQuestionTemplate';
import McqsQuestionMockTemplate from '../Templates/McqsQuestionMockTemplate';
import CompositeTemplate from '../Templates/CompositeTemplate';
import { ErrorSegment, ReportForm, Separator, TextEditor, VideoPlayer, WindowsManager } from '../../..';
import { Consts, Styles, Theme } from '../../../../res';
import iconImage from '../../../../res/images/logo.svg';
import '../../../../res/css/cpa.css';
import { replaceFontFamily } from '../../../../helpers/general';
import TbsPdfReader from '../TbsPdfReader';

const { noExtraSpaces, f_40_700_text, f_12_400_text, f_16_700_text, f_20_700_text } = Styles;

const QuestionPage = (props) => {
    const { Q, Qindex, FactIndex, onAnswerQuestion, loading, error, isMockExam, isViewOnly, user, questions, onSelectQuestion, onFlagQuestion, onFavQuestion, course, onHideSomeAnswers, onExcludeOption } = props;
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const [showReportIssue, setShowReportIssue] = useState(false);
    const [showExplanation, setShowExplanation] = useState(false);
    const [isSubmitClicked, setIsSubmitClicked] = useState(Q?.isSubmited);
    const [showAnswersType, setShowAnswersType] = useState("YOUR_ANSWER");
    const [wmStatus, wmSetStatus] = useState({});
    const wmRef = useRef();

    const handleOpen = (id) => wmRef.current?.openPopup(id);
    const handleClose = (id) => wmRef.current?.closePopup(id);
    const handleCloseAll = () => wmRef.current?.closeAll();
    const reshapePopups = (layout) => wmRef.current?.reshapePopups(layout);

    const handleShowAnswerType = (type) => {
        setShowAnswersType(type);
        if (type === "CORRECT_ANSWER") {
            Q?.attachments?.forEach((d, index) => d.type === "CORRECT_ANSWER" && handleOpen(index));
        }
    };


    useEffect(() => {
        setIsSubmitClicked(Q?.isSubmited);
        setShowAnswersType("YOUR_ANSWER");
    }, [Q]);

    if (loading || !Q) return <Segment basic style={{ height: '40vh', ...noExtraSpaces }} loading={loading} />;
    if (error) return <ErrorSegment />;

    const disablePopupsButton = !Object.values(wmStatus)?.filter(w => w.open)?.length;

    const renderMcqsTemplate = () => {
        if (Q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS) {
            if (isMockExam)
                return <McqsQuestionMockTemplate Q={Q} onAnswerQuestion={onAnswerQuestion} isViewOnly={isViewOnly} onExcludeOption={onExcludeOption} />;
            else return <McqsQuestionTemplate Q={Q} onAnswerQuestion={onAnswerQuestion} isViewOnly={isViewOnly} onHideSomeAnswers={onHideSomeAnswers} onExcludeOption={onExcludeOption} />;
        }
        return null;
    };

    return (
        <Segment basic style={{ ...noExtraSpaces, backgroundColor: "#ececec", minHeight: '85vh' }}>

            <div className={`${Q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS && "tw-mx-auto"}`} style={{ width: '50vw', position: 'relative', height: "100%" }}>

                <div style={{ padding: 5, display: 'flex', flexDirection: 'row', gap: 10, overflowX: 'auto' }}>
                    {questions.map((q, index) => {
                        const isSelected = Qindex === index;
                        const isAnswerd = q?.answerOptionId || q?.answerText || q?.answerJson;
                        const isCorrect = (q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS && q?.answerOptionId === q?.correctAnswer?.correctAnswerOptionId) || (isViewOnly && q?.isPassed);
                        const isWrong = isAnswerd && (q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS && q?.answerOptionId !== q?.correctAnswer?.correctAnswerOptionId);
                        return <div key={index} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'center', alignItems: 'center' }} onClick={() => onSelectQuestion(q)}>
                            <div><Header style={{
                                ...f_12_400_text,
                                fontWeight: (isSelected && !isAnswerd && !isSubmitClicked) ? f_20_700_text.fontWeight : f_12_400_text.fontWeight,
                                fontSize: (isSelected && !isAnswerd && !isSubmitClicked) ? f_20_700_text.fontSize : f_12_400_text.fontSize,
                                color: isSelected ? Theme.colors.CPA_ORANGE : isWrong ? Theme.colors.ERROR_100 : isCorrect ? Theme.colors.SECONDARY_50 : isAnswerd ? Theme.colors.GOLD : Theme.colors.CPA_NAVY,
                                border: isSelected && "dashed 1px #ccc",
                                padding: isSelected && 3
                            }}>
                                {index + 1}</Header>
                            </div>
                            {!!q.isFlagged && <Icon size='tiny' name="bookmark" inverted style={{ color: 'maroon' }} />}
                        </div>;
                    })}
                </div>

                <div style={{ backgroundColor: "white", borderLeft: `solid 3px ${Theme.colors.CPA_ORANGE}`, boxShadow: "2px 2px 5px #aaaaaa" }}>
                    <div style={{ padding: 10 }}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <Icon link size='big' style={{ color: '#043a4e' }} disabled={Qindex <= 0} onClick={() => onSelectQuestion(questions[Qindex - 1])} name='caret left' />
                            <div><Header style={{ ...f_40_700_text, color: "maroon" }}>{Q.factId ? FactIndex + 1 : Qindex + 1}</Header></div>
                            <Icon link name={Q.isFlagged ? "bookmark" : "bookmark outline"} inverted style={{ color: 'maroon' }} onClick={() => onFlagQuestion(Q)} />
                            {!isMockExam && <Icon link name={Q.isFav ? "star" : "star outline"} inverted style={{ color: 'maroon' }} onClick={() => onFavQuestion(Q)} />}
                            <Icon link size='big' style={{ color: '#043a4e' }} disabled={Qindex >= questions.length - 1} onClick={() => onSelectQuestion(questions[Qindex + 1])} name='caret right' />
                            <div className='tw-mx-auto tw-text-center'>
                                <Header style={{ ...f_16_700_text, color: "maroon", marginBottom: 0, marginTop: 0, }}>{course.name}</Header>
                            </div>
                            {!isMockExam && <Icon size='large' title={t('ReportProblem')} name='exclamation triangle' color='red' link onClick={() => setShowReportIssue(true)} style={{ marginLeft: 'auto' }} />}
                        </div>

                        <div className='tw-flex tw-flex-row tw-items-center tw-justify-end tw-gap-5'>
                            {Q?.sourceTxt && <div className='tw-bg-PRIMARY_05 tw-px-5 tw-py-1 tw-rounded-full tw-text-sm'>{Q.sourceTxt}</div>}
                            {Q?.questionConcept && <div></div>}
                        </div>

                        {Q.questionText && <div className="widget-container">
                            {Q.factId && <HtmlEditor value={replaceFontFamily(Q.factContent.trim())} readOnly style={{ border: 'none', minHeight: '35vh', height: '35vh' }} className='resizo' />}
                            <Separator h='1vh' />
                            <HtmlEditor value={replaceFontFamily(Q.questionText.trim())} readOnly style={{ border: 'none' }} className='resizo' />
                        </div>}

                        {Q.questionTypeId === Consts.QUESTIONS_TYPES.COMPOSITE &&
                            Q.attachments?.filter(d => d.type !== "CORRECT_ANSWER").length > 0 && <div className='exhibit-management' style={{ border: '1px solid #e6e6e6', backgroundColor: '#fbfbfb', padding: '14px 10px 0', marginBottom: '8px' }}>
                                <div style={{ fontSize: '15px', fontFamily: 'roboto_condensedbold, sans-serif', color: '#043a4e', marginBottom: '25px', display: 'inline-block', position: 'relative', top: '-5px' }}>{t('EXHIBITS')}</div>
                                <div className='exhibit-tools' style={{ float: 'right', width: '150px', marginTop: '-6px', marginRight: '-15px' }}>
                                    <a className="tool-button" title="Cascade Exhibit Windows" disabled={disablePopupsButton} aria-label="Cascade Exhibit Windows" onClick={() => reshapePopups("stack")}><span className="cascade"></span></a>
                                    <a className="tool-button" title="Tile Exhibit Windows" disabled={disablePopupsButton} onClick={() => reshapePopups("grid")}><span aria-label="Tile Exhibit Windows" className="tile"></span></a>
                                    <a className="tool-button" title="Close all exhibits" aria-label="Close all exhibits" disabled={disablePopupsButton} onClick={() => handleCloseAll()}><span className="close-all"></span></a>
                                </div>
                                <div className="exhibit-container">
                                    {
                                        Q.attachments?.map((d, i) =>
                                            <span key={d.docId}>
                                                <span className="exhibit-link" onClick={() => handleOpen(i)} style={{ display: d.type === "CORRECT_ANSWER" && 'none' }}>
                                                    <a title={isArabic ? d.nameAr : d.nameEn} aria-label={isArabic ? d.nameAr : d.nameEn} >
                                                        <span className="exhibit-icon"></span>{isArabic ? d.nameAr : d.nameEn}
                                                    </a>
                                                </span>
                                            </span>
                                        )
                                    }
                                </div>
                            </div>}

                        {renderMcqsTemplate()}
                        {Q.questionTypeId === Consts.QUESTIONS_TYPES.COMPOSITE && <CompositeTemplate Q={Q} onAnswerQuestion={onAnswerQuestion} isViewOnly={isViewOnly} isMockExam={isMockExam} handleShowAnswerType={handleShowAnswerType} showAnswersType={showAnswersType} isAnswerd={Q?.answerJson ? true : false} />}
                        {Q.questionTypeId === Consts.QUESTIONS_TYPES.ESSAY && <TextQuestionTemplate Q={Q} onAnswerQuestion={onAnswerQuestion} isMockExam={isMockExam} isViewOnly={isViewOnly} />}


                        {Boolean(Q.questionTypeId === Consts.QUESTIONS_TYPES.COMPOSITE && (isViewOnly || (!isMockExam && Q?.isSubmited))) && <div className='tw-flex tw-flex-row tw-items-center tw-justify-end'>
                            <Button.Group>
                                <Button onClick={() => handleShowAnswerType("YOUR_ANSWER")} style={{ borderRadius: 0, backgroundColor: showAnswersType === "YOUR_ANSWER" && Theme.colors.CPA_ORANGE, color: showAnswersType === "YOUR_ANSWER" && Theme.colors.WHITE }}>{t("YourAnswer")}</Button>
                                <Button onClick={() => handleShowAnswerType("CORRECT_ANSWER")} style={{ borderRadius: 0, backgroundColor: showAnswersType === "CORRECT_ANSWER" && Theme.colors.CPA_ORANGE, color: showAnswersType === "CORRECT_ANSWER" && Theme.colors.WHITE }}>{t("CorrectAnswer")}</Button>
                            </Button.Group>
                        </div>}

                        {(!isMockExam && !isViewOnly && !isSubmitClicked) && Q?.questionTypeId !== Consts.QUESTIONS_TYPES.MCQS && <Segment basic clearing>
                            <Button
                                onClick={() => {
                                    setIsSubmitClicked(true);
                                    onAnswerQuestion(Q, true);
                                }}
                                floated='right'
                                style={{ borderRadius: 0, backgroundColor: Theme.colors.CPA_ORANGE, color: Theme.colors.WHITE }}>
                                {t("Submit")}
                            </Button>
                        </Segment>}

                        {((!isMockExam && isSubmitClicked) || isViewOnly) && <Segment basic clearing>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: 5 }}>
                                {
                                    Q.attachments?.map((d, i) => <Button
                                        key={d.docId}
                                        onClick={() => handleOpen(i)}
                                        style={{ display: d.type !== "CORRECT_ANSWER" && "none", borderRadius: 0, backgroundColor: Theme.colors.CPA_ORANGE, color: Theme.colors.WHITE }}>
                                        {t("Solution")}
                                    </Button>)
                                }

                                {Q?.questionTypeId !== Consts.QUESTIONS_TYPES.MCQS && Boolean(Q?.correctAnswer?.explanations?.videos?.length) && <Button
                                    icon="film"
                                    content={t('Explanation')}
                                    onClick={() => setShowExplanation(true)}
                                    style={{ borderRadius: 0, backgroundColor: Theme.colors.CPA_ORANGE, color: Theme.colors.WHITE }}
                                />}

                            </div>
                        </Segment>}
                    </div>

                    <Segment basic textAlign='center'>
                        <Icon link size='big' style={{ color: '#043a4e' }} disabled={Qindex <= 0} onClick={() => onSelectQuestion(questions[Qindex - 1])} name='caret left' />
                        <Icon link size='big' style={{ color: '#043a4e' }} disabled={Qindex >= questions.length - 1} onClick={() => onSelectQuestion(questions[Qindex + 1])} name='caret right' />
                    </Segment>

                    <div className='studentExamWatermark' style={{ top: '40%', left: '40%' }}>
                        <Image loading="lazy" size='medium' src={iconImage} />
                    </div>

                    <Header
                        as='h1'
                        content={`${user.firstName} ${user.lastName} [${user.email}] ${user.contactNumber}`}
                        className='studentExamWatermark'
                    />

                </div>
            </div>

            <Modal
                onClose={() => setShowReportIssue(false)}
                open={showReportIssue}
                content={<ReportForm reportOn={Consts.REPORTS_TYPES.QUESTION} reportLink={Q} id={Q.questionId} showModal={setShowReportIssue} />}
                closeIcon
                header={t('ReportProblem')}
                size='small'
                centered
                closeOnDimmerClick={false}
            />

            <Modal
                onClose={() => setShowExplanation(false)}
                open={showExplanation}
                content={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? <VideoPlayer kind={Consts.VIDEOS_KINDS.EXPLANATION} videoDetails={{ ...Q.correctAnswer.explanations.videos[0], ...Q }} onClose={() => setShowExplanation(false)} /> : <ErrorSegment text={t('ComingSoon')} icon='wait' />}
                basic={Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length ? true : false}
                size='large'
                centered
                closeIcon={!(Q && Q.correctAnswer && Q.correctAnswer.explanations && Q.correctAnswer.explanations.videos.length)}
                closeOnDimmerClick={false}
            />

            <WindowsManager ref={wmRef} setValue={wmSetStatus}>
                {Q.attachments?.map((d, i) => <div key={i} className={`tw-flex tw-h-full tw-w-full tw-flex-col tw-border-2 ${wmStatus?.[i]?.active ? "tw-border-CPA_NAVY" : "tw-border-gray-400"}`}>
                    <div className={`drag-handle tw-cursor-move tw-flex tw-flex-row tw-justify-between tw-px-2 tw-h-10 tw-items-center ${wmStatus?.[i]?.active ? "tw-bg-CPA_NAVY" : "tw-bg-gray-400"}`}>
                        <p className='tw-font-bold tw-text-WHITE tw-text-base tw-line-clamp-1 tw-text-ellipsis'>{isArabic ? d.nameAr : d.nameEn}</p>
                        <div><Icon link name='x' onClick={() => handleClose(i)} bordered className='tw-bg-CPA_ORANGE tw-text-WHITE' /></div>
                    </div>
                    {d.fsType === "FR_WORD" ?
                        <TextEditor isReadOnly data={{ value: "" }} docUrl={d.docUrl} style={{ border: 'none', boxShadow: 'none', backgroundColor: 'white', height: '100%' }} />
                        : <TbsPdfReader docUrl={d.docUrl} disableFontFace={false} width={wmStatus[i]?.width} height={wmStatus[i]?.height} />}
                </div>
                )}
            </WindowsManager>

        </Segment >
    );
};

export default QuestionPage;